import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const InfoTooltip = ({ title, message, color = "#7BC1FE", sx }) => {
  if (!message) return null;
  return (
    <Tooltip title={message} arrow>
      <InfoOutlinedIcon
        aria-label={title}
        sx={{
          fontSize: 20,
          ml: 0.5,
          verticalAlign: "middle",
          cursor: "help",
          color,
          ...sx,
        }}
      />
    </Tooltip>
  );
};

export default InfoTooltip;
